import { render, staticRenderFns } from "./ClassSpellManager.vue?vue&type=template&id=0864686f&scoped=true"
import script from "./ClassSpellManager.vue?vue&type=script&lang=js"
export * from "./ClassSpellManager.vue?vue&type=script&lang=js"
import style0 from "./ClassSpellManager.vue?vue&type=style&index=0&id=0864686f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0864686f",
  null
  
)

export default component.exports